import { useMutation, gql } from 'urql';

export interface Organizer {
  id: number;
  firstName: string;
  lastName: string;
  phone: string;
}

const UPDATE_ORGANIZER_MUTATION = gql`
  mutation UpdateOrganizer($userId: Int!, $input: UpdateUser!) {
    updateUser(userId: $userId, input: $input) {
      id
      firstName
      lastName
      phone
    }
  }
`;

interface UpdateUserInput {
  firstName: string;
  lastName: string;
  phone: string;
}

interface UpdateOrganizerVariables {
  userId: number;
  input: UpdateUserInput;
}

interface UpdateOrganizerResponse {
  updateOrganizer: Organizer;
}

export const useUpdateOrganizerMutation = () => {
  return useMutation<UpdateOrganizerResponse, UpdateOrganizerVariables>(UPDATE_ORGANIZER_MUTATION);
};
